'use strict'

const $ = window.jQuery

module.exports = function () {
    if ( $('.page-arpej').length <= 0 ) {
        return
    }

    // Big scroll animation
    gsap.registerPlugin(ScrollTrigger, SplitText)

    let introSplit = new SplitText('.splash__intro', {type : 'chars'})
    let tlIntro = gsap.timeline({
        scrollTrigger: {
            trigger: '.splash',
            start: 'top 85px',
            scrub: 2,
            pin: true
        },
    })
    let tlMissions = gsap.timeline({
        scrollTrigger: {
            trigger: '.page-arpej__missions',
            start: 'top 85px',
            scrub: 1
        },
    })

    tlIntro.staggerFrom(introSplit.chars, .5, {
        opacity: 0,
        scale: 0,
        y: 80,
        rotationX: 180,
        transformOrigin: "0% 50% -50",
        stagger: 0.01
    }).to('.splash__img-logo', {
        opacity: 1
    }, 0).to('.splash__img-logo, .splash__img-sign', {
        scale: .7
    }).to('.splash__img-txt', {
        scale: .25,
        y: -150,
        opacity: 1
    }).to('.splash__intro', {
        opacity: 0
    }).to('.btn-play', {
        opacity: 1
    })

    tlMissions.to('.graphic-elt--first', {
        y: 200
    }).to('.graphic-elt--second', {
        y: 300
    }, 0).to('.graphic-elt--third', {
        y: 200
    }, 0).to('.graphic-elt--side-l', {
        y: 600
    }, 0).to('.graphic-elt--side-r', {
        y: 600
    }, 0)

    // History
    const carouselHistory = new Swiper('.page-arpej__history', {
        slidesPerView: 2,
        grabCursor: true,
        parallax: true,
        centeredSlides: true,
        scrollbar: {
            el: '.swiper-scrollbar',
        },
        breakpoints: {
            1024: {
                slidesPerView: '3'
            }
        }
    })

    $('.history-more').on('click', function () {
        $('.popin-history__year, .popin-history__year-bg').empty().append( $(this).data('year') )
        $('.popin-history__title').empty().append( $(this).data('title') )
        $('.popin-history__content').empty().append( $(this).data('content') )
    })

    // Testimonials
    const carouselTestimonials = new Swiper('.page-arpej__testimonials', {
        autoplay: true,
        slidesPerView: 1,
        grabCursor: true,
        parallax: true,
        speed: 500,
        navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
        },
    })
}
